import { Component } from '@angular/core';
import { AccessCodesPage } from '../../pages/access-codes/access-codes';
import { PartnersPage } from '../../pages/partners/partners';
import { MyGatesPage } from '../../pages/my-gates/my-gates';


import { NavController } from 'ionic-angular';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  constructor(public navCtrl: NavController) {
        
  }
    accessCode(){
        this.navCtrl.push(AccessCodesPage);
    }
   partners(){
        this.navCtrl.push(PartnersPage);
    }
  login(){
        this.navCtrl.push(MyGatesPage);
    }
    ionViewDidLoad() {
        console.log('ionViewDidLoad HomePage');

 //       window.location.replace('https://GateGoing.com'); 
      } 

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts